import { useEffect } from "react";
import { useRouter } from "next/router";
import Loading from "../../components/Loading";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

function Account() {
  const router = useRouter();
  useEffect(() => {
    if (router.isReady) {
      router.push({
        pathname: "/account/rental_orders",
        query: router.query,
      });
    }
  }, [router.isReady]);
  return <Loading />;
}

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
export default Account;
